import api, { unwrap } from './client';

// opts.forecast=true → 12 mois adossés au bilan hybride (vue prévisionnelle).
// opts.through → arrêté d'affichage : la vue se borne à ce mois (≤ clôture).
export const getCfView = (tenantId, year, opts = {}) =>
    unwrap(api.get(`/financials/cf/${tenantId}`,
      { params: { year, ...(opts.forecast ? { forecast: true } : {}),
      ...(opts.version ? { version: opts.version } : {}),
      ...(opts.through ? { through: opts.through } : {}) } }));
